import { create } from 'zustand';
import { ApiUtils, ApplicationApi, AssignManualApplicationRequest, RequestStrategyEnum } from '@shared/api';

interface IAssignManualApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  assignManualApplication: (searchParams: AssignManualApplicationRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAssignManualApplicationStore = create<IAssignManualApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  assignManualApplication: ApiUtils.wrapperApi(async (searchParams: AssignManualApplicationRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.assignManualApplication(searchParams, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
